import $ from 'jquery'
import settings from '../../utils/settings'

class Module {
  constructor ($module) {
    this.$form = $module.find('.js-network-form')
    this.$tnx = $module.find('.js-network-tnx')

    this.bind()
  }

  bind () {
    this.$form.submit((e) => {
      e.preventDefault()
      this.submitForm()
    })
  }

  submitForm () {
    this.$form.fadeOut(settings.TRANSITION_SPEED, () => {
      this.$tnx.fadeIn(settings.TRANSITION_SPEED)
    })

    const action = this.$form.attr('action')
    const data = this.$form.serialize()

    $.post(action, data)
  }
}

$(function () {
  $('.js-main').each(function () {
    new Module($(this))
  })
})
